import React from 'react';


export const Database = props => {
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0023 0C6.54304 0 2.11719 1.61332 2.11719 3.60443V6.56206C2.11719 8.55342 6.54304 10.1662 12.0023 10.1662C17.4613 10.1662 21.8872 8.55317 21.8872 6.56206V3.60443C21.8872 1.61332 17.4613 0 12.0023 0Z"
                fill="black"/>
            <path
                d="M12.0025 11.8899C6.79025 11.8899 2.4931 10.4182 2.11734 8.552C2.09942 8.64108 2.11734 13.4364 2.11734 13.4364C2.11734 15.428 6.54319 17.0408 12.0025 17.0408C17.4615 17.0408 21.8873 15.4275 21.8873 13.4364C21.8873 13.4364 21.8984 8.64083 21.8808 8.552C21.5045 10.4184 17.2144 11.8899 12.0025 11.8899Z"
                fill="black"/>
            <path
                d="M21.8788 15.511C21.5033 17.3762 17.2155 18.8487 12.0033 18.8487C6.79111 18.8487 2.49295 17.3759 2.11719 15.511L2.1182 20.3956C2.1182 22.387 6.54405 23.9998 12.0033 23.9998C17.4623 23.9998 21.8882 22.3865 21.8882 20.3956L21.8788 15.511Z"
                fill="black"/>
        </svg>
    )
};
